import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { ScrollToTop } from './components/ScrollToTop';
import { AlertBar } from './components/AlertBar';
import { Footer } from './components/Footer';
import { EspaceProvider } from './contexts/EspaceContext';
import { EspaceLayout } from './components/espace/EspaceLayout';
import { Accueil } from './pages/Accueil';
import { MaCarte } from './pages/MaCarte';
import { MesCollectes } from './pages/MesCollectes';
import { CalendrierCollectes } from './pages/CalendrierCollectes';
import { MonProfil } from './pages/MonProfil';
import { MesLoisirs } from './pages/MesLoisirs';
import { AvisNotifications } from './pages/AvisNotifications';
import { ParametresAvis } from './pages/ParametresAvis';
import { MesDemandes } from './pages/MesDemandes';
import { DemandeDetail } from './pages/DemandeDetail';
import { MonEspace } from './pages/MonEspace';
import { MesAnimaux } from './pages/MesAnimaux';
import { Plan } from './pages/Plan';
import { AnimalDetail } from './pages/AnimalDetail';
interface AppProps {
  showAlertBar?: boolean;
  showEvents?: boolean;
}
export function App({
  showAlertBar = true,
  showEvents = true
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="3reltuemj9e7n">
      <EspaceProvider data-id="element-1" data-mp="5otf64sd496">
        <div id="accueil" className="min-h-screen w-full bg-white" data-id="element-2" data-mp="680frswe88f">
          <ScrollToTop data-id="element-3" data-mp="2zl3cjn8vpa6d" />
          <div className="sticky top-0 z-40" data-id="element-4" data-mp="2zlv6yuqqp1v2">
            <Header data-id="element-5" data-mp="2zn6actg9w7ln" />
            {showAlertBar && <AlertBar data-id="element-6" data-mp="33m5b01uz1i7a" />}
          </div>
          <EspaceLayout data-id="element-7" data-mp="33n6yx6x35z6f">
            <Routes data-id="element-8" data-mp="33orkw85c49so">
              <Route path="/" element={<Accueil showEvents={showEvents} data-id="element-10" data-mp="38li6tc3tlzm0" />} data-id="element-9" data-mp="38m1gy6n8bjph" />
              <Route path="/map" element={<Plan data-id="element-12" data-mp="3dkl0y1i9ilf7" />} data-id="element-11" data-mp="38o4fxg6d0n6c" />
              <Route path="/my-card" element={<MaCarte data-id="element-14" data-mp="3dm5vhr4ku4d2" />} data-id="element-13" data-mp="3dlw4q1bpjt6b" />
              <Route path="/my-collections" element={<MesCollectes data-id="element-16" data-mp="nuhiqjqwkdut" />} data-id="element-15" data-mp="nvj179a902mk" />
              <Route path="/my-collections/calendar" element={<CalendrierCollectes data-id="element-18" data-mp="stue5svuat90" />} data-id="element-17" data-mp="nxn6nvnsp9oy" />
              <Route path="/my-profile" element={<MonProfil data-id="element-20" data-mp="36hvn4muyo06" />} data-id="element-19" data-mp="sssqmoxn0eae" />
              <Route path="/my-recreation" element={<MesLoisirs data-id="element-22" data-mp="34nd1wz277z9" />} data-id="element-21" data-mp="35ovwnmbgyrj" />
              <Route path="/notifications" element={<AvisNotifications data-id="element-24" data-mp="3ubriinfk2m5k" />} data-id="element-23" data-mp="3ud1hdeu8fyd9" />
              <Route path="/notifications/settings" element={<ParametresAvis data-id="element-26" data-mp="d4xr1jsx4jfh" />} data-id="element-25" data-mp="3uevui6z9im6s" />
              <Route path="/my-requests" element={<MesDemandes data-id="element-28" data-mp="85l0anyxes7m" />} data-id="element-27" data-mp="d3wch5cp1et0" />
              <Route path="/my-requests/:id" element={<DemandeDetail data-id="element-30" data-mp="83i2hhrj7usc" />} data-id="element-29" data-mp="86meh1b8nutk" />
              <Route path="/my-dashboard" element={<MonEspace data-id="element-32" data-mp="3gm66jx06b771" />} data-id="element-31" data-mp="3gl4pnbwh7qhe" />
              <Route path="/my-pets" element={<MesAnimaux data-id="element-34" data-mp="3bmjnv81ksyqu" />} data-id="element-33" data-mp="3gja887keygi2" />
              <Route path="/my-pets/:id" element={<AnimalDetail data-id="element-36" data-mp="3bk72sm0iu89k" />} data-id="element-35" data-mp="3bnmgbkejr98v" />
              <Route path="*" element={<Accueil showEvents={showEvents} data-id="element-38" data-mp="3qc948ai8p9bp" />} data-id="element-37" data-mp="3qbpon0g2ax0u" />
            </Routes>
          </EspaceLayout>
          <Footer data-id="element-39" data-mp="3ljg09ouli50o" />
        </div>
      </EspaceProvider>
    </BrowserRouter>;
}